export default __webpack_public_path__ + "static/media/sold_down_the_river.96679bb0.png";